<ng-container *transloco="let t">
  <form [formGroup]="formGroup" class="flex-column" style="gap: 15px;">
      <span class="dance-style-role-header">Select your role</span>
      <div class="dance-style-role-text flex-row" style="gap: 20px;">
          <mat-checkbox formControlName="isFollower">{{ t('GENERIC_WRAPPER.FOLLOWER') }}</mat-checkbox>
          <mat-checkbox formControlName="isLeader">{{ t('GENERIC_WRAPPER.LEADER') }}</mat-checkbox>
      </div>
  </form>
</ng-container>
